(function ($) {
	$.fn.dwell = function(callback, tolerance_px) {
		var $ = this, timer, stop, track, last_pos = [0, 0], pos = [];

		if (tolerance_px === undefined) {
			tolerance_px = 10;
		}

		track = function(event) {
			pos = [event.pageX, event.pageY];

			if (!timer) {
				timer = window.setInterval(function() {
					if (Math.abs(pos[0] - last_pos[0]) < tolerance_px &&
						Math.abs(pos[1] - last_pos[1]) < tolerance_px) {
						stop();
						callback.apply($);
					}
					last_pos = pos;
				}, 50);
			}
		};

		stop = function() {
			window.clearInterval(timer);
			timer = undefined;
		};

		this.bind("mousemove", track).bind("mouseleave", stop);

		return this;
	};

}(window.jQuery));
